import jQuery from 'jquery';

const localisation = {
  switcher: {
    expand: 'Развернуть',
    collapse: 'Свернуть',
  },
};

jQuery(function($) {
  let $spoilers = $('.spoiler');

  $spoilers.each(function() {
    let $spoiler = $(this);
    let $spoilerWrapper = $spoiler.find('.spoiler__wrapper');
    let visibleCount = $spoiler.data('visibleCount');

    let $spoilerItems = $spoilerWrapper.find('.spoiler__item');

    if ($spoilerItems.length <= visibleCount) {
      return;
    }

    let $spoilerItemsHidden = $spoilerItems.slice(visibleCount);
    $spoilerItemsHidden.addClass('d-none');

    let $spoilerSwitcher = $('<a>', {
      'href': 'javascript:void(0);',
      'class': 'spoiler__switcher',
      'text': localisation.switcher.expand,
    });
    $spoiler.append($spoilerSwitcher);

    const $float = $spoiler.closest('.float');
    if ($float) {
      const $track = $($float.data('trackSelector'));
      $track.css({
        'min-height': `${ $spoiler.height() }px`,
      });
    }

    $spoilerSwitcher.on('click', function() {
      let isCollapsed = $spoiler.data('isCollapsed');

      $spoilerItemsHidden.toggleClass('d-none', isCollapsed);
      $spoilerSwitcher.text(isCollapsed ? localisation.switcher.expand : localisation.switcher.collapse);
      $spoilerSwitcher.toggleClass('spoiler__switcher--collapse', !isCollapsed);

      if ($float) {
        const $track = $($float.data('trackSelector'));
        $track.css({
          'min-height': isCollapsed ? `${ $spoiler.height() }px` : $track.data('min-height'),
        });
      }

      $spoiler.data('isCollapsed', !isCollapsed);

      $(window).trigger('scroll');
    });
  });
});
